import { EnvironmentTypes } from '../constants/environmentTypes';

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
export const isStage = () => {
  return process.env.REACT_APP_ENV === EnvironmentTypes.Development;
};
